var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"events-layout",class:{ 'event-layout-darker': _vm.$route.name === 'events-teams-join' }},[_c('events-header'),_vm._v(" "),_c('div',{staticClass:"position-relative"},[_c('nuxt')],1),_vm._v(" "),_c('modal')],1),_vm._v(" "),_c('chat'),_vm._v(" "),_c('toaster'),_vm._v(" "),_c('events-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }